export default __webpack_public_path__ + "static/media/approved.08feaa0e.svg";